<template>
  <div class="order-search-page">
    <h2>Order Search</h2>
    <hr>
    <div class="row pb-4">
      <div class="col">
        <div class="col">
          <BasicTextInput label='Product #' v-model="orderSearch.productNumber"/>
        </div>
        <!--
        <div class="col">
          <BasicTextInput label='Product Description' v-model="orderSearch.productDescription"/>
        </div>
        -->
        <div class="col">
          <!-- <BasicTextInput label='MFG'  v-model="orderSearch.manufacturer"/> -->
          <div class="font-weight-normal">Manufacturer</div>
          <DxSelectBox
              placeholder="Search..."
              :search-enabled="true"
              :data-source="manufacturersByDealer"
              :search-mode="searchModeOption"
              :search-expr="searchExprOption"
              :search-timeout="searchTimeoutOption"
              :min-search-length="minSearchLengthOption"
              :show-data-before-search="showDataBeforeSearchOption"
              display-expr="DisplayName"
              value-expr="DisplayName"
              v-model="orderSearch.manufacturer"
              :wrapper-attr="popupAttributes"
            />
        </div>
      </div>
      <div class="col">
        <div class="col">
          <BasicTextInput label='Stock Code' v-model="orderSearch.stockCode"/>
        </div>
        <div class="col">
          <BasicDropdown label='Order Status' :items="orderStatusOptionsFiltered" v-model="orderSearch.orderStatus" :key="orderStatusUpdateKey"/>
        </div>
      </div>
    </div>
    <div class="subheader-wrapper">
      <h4>Orders</h4>
      <div class="icon-group">

        <button type="button" @click="getFilteredOrders" class="btn btn-primary" style="margin-right: 10px">
          <i class="fa fa-search" aria-hidden="true"></i> Search
        </button>
        <button type="button" @click="clearSearchFilters" class="btn btn-secondary" style="margin-right: 25px">
          <i class="fa fa-search-minus" aria-hidden="true"></i> Show ALL
        </button>

        <router-link v-if="!isLimitedTransferUser" :to="{ name: 'CustomerOrder' }" class=""><i class="fa fa-plus" aria-hidden="true"></i></router-link>
        <!--
        <button @click="goToMostRecentOrder" class="icon-btn">
            <i class="fa fa-forward" aria-hidden="true"></i>
          </button>
        -->
        <!-- <button class="icon-btn" @click="toggleCommitCheck(true)" :disabled="selectedRowsEmpty">
          <i class="fa fa-check-circle"  aria-hidden="true"></i>
        </button> -->
        <button v-if="!isLimitedTransferUser" class="icon-btn" :disabled="selectedRowsEmpty" @click="toggleDeleteCheck(true)">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
        <!-- <i class="fa fa-file" aria-hidden="true"></i> -->
      </div>

    </div>

    <hr>
    <BasicDataGrid
      ref="orderSearchDataGrid"
      :key="dataGridUpdateKey"
      :dataSource="dataSource"
      gridRef="orderSearchGrid"
      :dataGridKey="dataGridKey"
      :columns="dynamicColumns"
      :actions="actions"
      :allowExport="false"
      :showColumnLines="true"
			:stateStoring="true"
      :searchEntireGrid="false"
      v-on:clear-search="clearSearchFilters"
      @selectedRowsChanged="selectedRowsChanged"
      @deleteOrder="deleteFromGrid"
      @undeleteOrder="undeleteFromGrid"
      @commit="commitFromGrid"
      @viewOrder="viewOrder"
      @editOrder="editOrder"/>

      <Modal ref="deleteCheck">
        <div class="card modal-wrapper p-4" :class="{ 'modal-wrapper-wide': multipleOrders && selectedRows.length >= 2 }">
          <div v-if="!multipleOrders || selectedRows.length < 2">
            <p class="m-0">Are you sure you would like</p>
            <p class="mt-0 ">to delete this order?</p>
            <div class="btn-wrapper center">
              <button class="btn btn-secondary" @click="toggleDeleteCheck">Cancel</button>
              <button @click="deleteConfirmed" class="btn btn-primary">Delete</button>
            </div>
          </div>
          <div v-else-if="multipleOrders && selectedRows.length >= 2">
            <p class="m-0">You are about to delete <strong>{{ selectedRows.length }}</strong> orders.</p>
            <p class="mt-2 mb-3">To confirm, please type <strong>"delete"</strong> below:</p>
            <BasicTextInput
              v-model="deleteConfirmationText"
              placeholder="Type 'delete' to confirm"
              :focus="true"
              class="mb-3"
            />
            <div class="btn-wrapper center">
              <button class="btn btn-secondary" @click="toggleDeleteCheck">Cancel</button>
              <button
                @click="deleteConfirmed"
                class="btn btn-primary"
                :disabled="deleteConfirmationText.toLowerCase() !== 'delete'"
              >
                Delete {{ selectedRows.length }} Orders
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal ref="commitCheck">
        <div class="card modal-wrapper p-4">
          <p class="m-0">Are you sure you would like</p>
          <p class="mt-0 ">to commit order?</p>
          <div class="btn-wrapper center">
            <button class="btn btn-secondary" @click="toggleCommitCheck">Cancel</button>
            <button @click="commit" class="btn btn-primary">Commit</button>
          </div>
        </div>
      </Modal>

      <Modal ref="orderPreviewDialog">
        <OrderPreview :orderId="selectedOrderId"/>
      </Modal>
  </div>
</template>
<script>
import BasicDataGrid from '../../../components/BasicDataGrid.vue';
import DxDataGrid from 'devextreme-vue/data-grid';
import OrderPreview from '../../../components/OrderPreview.vue';
import { DxSelectBox } from 'devextreme-vue/select-box';
import { OrderService, DealerService, TableConfigService } from '../../../services';
import { mapState } from 'vuex'
import { userRoleEnum , getKeyByValue } from "../../../modules/helpers.js";

import 'devextreme/dist/css/dx.light.css';

export default {
  name: 'OrderSearch',
  components: {
    BasicDataGrid,
    DxSelectBox,
    DxDataGrid,
    OrderPreview
  },
  data() {
    // const manufacturers = DealerService.manufacturersByDealer();
    // const serviceUrl = DealerService.manufacturersByDealer();
    //     const store = createStore({
    //         key: "ID",
    //         loadUrl: serviceUrl
    //     });
    // console.log(store);
    return {
      // data,
      // editBoxValue: simpleProducts[0],
      // product: simpleProducts[0].ID,
      searchModeOption: 'contains',
      searchExprOption: 'DisplayName',
      searchTimeoutOption: 200,
      minSearchLengthOption: 0,
      showDataBeforeSearchOption: false,
      searchExprItems: [
        {
          name: "'DisplayName'",
          value: 'DisplayName',
        },
        // {
        //   name: "['Name', 'Category']",
        //   value: ['Name', 'Category'],
        // },
      ],
      dataGridKey: 'Id',
      dataGridUpdateKey: 1,
      dataSource: [],
      manufacturersByDealer: [],
      actions: [
        {
          key: 'delete',
          hint: 'Delete',
          icon: 'trash',
          emit: 'deleteOrder',
          visible: (e) => !e.row.data.IsDeleted
        },
        {
          key: 'undelete',
          hint: 'Undelete',
          icon: 'undo',
          emit: 'undeleteOrder',
          visible: (e) => e.row.data.IsDeleted && this.canViewDeletedOrders
        },
        {
          key: 'edit',
          hint: 'Edit',
          icon: 'edit',
          emit: 'editOrder',
          visible: (e) => !e.row.data.IsDeleted
        },
        {
          key: 'open',
          hint: 'Preview Order',
          icon: 'info',
          emit: 'viewOrder'
        }
      ],
      multipleOrders: false,
      orderStatusUpdateKey: 0,
      orderSearch: {
        productNumber: null,
        productDescription: null,
        stockCode: null,
        orderStatus: 4,
        manufacturer: null,
        owner: null
      },
      orderStatusOptions: [
        {text: 'All', value: 4},
        {text: 'Uncommitted', value: 1},
        {text: 'Committed', value: 2},
        {text: 'Submitted', value: 3},
        {text: 'Deleted', value: 5, requiresDeletedAccess: true}
      ],
      selectedRows: [],
      defaultcolumns: [
        {text: 'Order #', width: '150px', value: 'OrderNumber', dataType: "string"},
        {text: 'Order Date', width: '100px', value:'CreatedOn', dataType: "date", sortOrder: 'desc'},
        {text: 'Order Owner', width: '175px', value:'SalesRepFullName', dataType: "string"},
        {text: 'Worksheet Name', width: 'auto', value:'WorksheetName', dataType: "string"},
        {text: 'Customer #', width: '75px', value:'JdeNumber', dataType: "string"},
        {text: 'Bill Name', width: 'auto', value:'BillingInfo.Name', dataType: "string"},
        {text: 'Bill State', width: '75px', value:'BillingInfo.StateProvince', dataType: "string"},
        {text: 'Bill City', width: '75px', value:'BillingInfo.City', dataType: "string"},
        {text: 'Ship Name', width: '75px', value:'ShippingInfo.Name', dataType: "string"},
        {text: 'Ship State', width: '75px', value:'ShippingInfo.StateProvince', dataType: "string"},
        {text: 'Ship City', width: '75px', value:'ShippingInfo.City', dataType: "string"},
        {text: 'Install Date', width: '75px', value:'InstalledOn', dataType: "date"},
        {text: 'Revise Date', width: '75px', value:'RevisedOn', dataType: "date"},
        {text: 'Expire Date', width: '75px', value:'ExpiresOn', dataType: "date"},
        {text: 'Status', width: '75px', value:'IsDeleted', dataType: "boolean", cellTemplate: 'statusTemplate', visible: false}
      ],
      columns: [],
      submittedId: 3,
      orderId: 0,
      popupAttributes: {
          id: 'elementId',
          class: 'dxSelect'
      },
      selectedOrderId: 0,
      isLimitedTransferUser: false,
      deleteConfirmationText: ''
    };
  },
  methods: {
    getDisplayExpr(item) {
      //console.log(item);
      return item && item.DisplayName;
    },
    clearSearchFilters() {
      // Clear the form filters
      this.orderSearch = {
        productNumber: null,
        productDescription: null,
        stockCode: null,
        orderStatus: 4,
        manufacturer: null,
        owner: null
      }

      // Clear the grid-level filters (column filters, search panel, etc.)
      if (this.$refs.orderSearchDataGrid) {
        this.$refs.orderSearchDataGrid.clearSearchPanel();
      }

      this.dataGridUpdateKey = this.dataGridUpdateKey + 1;
      this.orderStatusUpdateKey++
      this.getFilteredOrders()
    },
    goToMostRecentOrder(){
      OrderService.mostRecent()
        .then(res => {
          this.$router.push({ name: 'CustomerOrderEdit', params: { id: res.Id, cid: res.CustomerId } } );
        })
        .catch(err => {
          console.log(err)
        })
    },
    editOrder(e){
      let orderId = e.row.data.Id;
      let customerId = e.row.data.CustomerId;
      this.$router.push({ name: 'CustomerOrderEdit', params: { id: orderId, cid: customerId } } );
    },
    viewOrder(e) {
      this.selectedOrderId = e.row.data.Id;
      this.$refs.orderPreviewDialog.openModal();
    },
    openOrder(e) {
      const orderId = e.row.data.Id;
      const customerId = e.row.data.CustomerId;
      const routeData = this.$router.resolve({ name: 'CustomerOrderEdit', params: { id: orderId, cid: customerId } });
      window.open(routeData.href, '_blank');
    },
    deleteFromGrid(e){
      this.toggleDeleteCheck(false)
      // this.order = e.row.data
      this.orderId = e.row.data.Id;
    },
    undeleteFromGrid(e){
      this.undeleteOrder(e.row.data.Id);
    },
    commitFromGrid(e){
      this.toggleCommitCheck(false)
      this.order = e.row.data
      this.orderId = [e.row.data.Id];
      // this.commitOrders(orderId)

    },
    commit(){
      this.multipleOrders ?
      this.commitMultipleRows() :
      this.commitOrders(this.orderId)
    },
    commitOrders(ids, message){
      let commitMessage = message || 'Order Committed'
      if(this.order.OrderStatusId === this.submittedId) {
        this.$store.dispatch('ADD_NOTIFICATION', { text: 'This order has already been submitted' , type: 'error' });
        this.order = {};
        this.toggleCommitCheck()
        return;
      }
      else if(this.order.InstalledOn === null){
        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Please add an Installation Date to the order before committing' , type: 'error' });
        this.order = {};
        this.toggleCommitCheck()
        return;
      }
      OrderService.commit(ids)
        .then(() => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: commitMessage , type: 'success' });
          this.selectedRows = []
        })
        .catch((err) => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
        })
        this.toggleCommitCheck()
    },
    toggleCommitCheck(multiple){
      this.multipleOrders = multiple;
      this.$refs.commitCheck.toggle();
    },
    toggleDeleteCheck(multiple){
      this.multipleOrders = multiple;
      // Reset confirmation text when opening the modal
      this.deleteConfirmationText = '';
      // Debug logging
      console.log('toggleDeleteCheck - multipleOrders:', this.multipleOrders, 'selectedRows.length:', this.selectedRows.length);
      this.$refs.deleteCheck.toggle();
    },
    commitMultipleRows(){
      let committedRows = []
      let unableToCommit = []
      let ableToCommit = []
      this.selectedRows.forEach(row => {
        //console.log('row', row)
        if(row.OrderStatusId === this.submittedId || row.InstalledOn === null){
          unableToCommit.push(row.Id)
        }else {
          committedRows.push(row.Id)
          ableToCommit.push(row.Id)
        }

      })
      if(unableToCommit.length > 0){
        let message = "Unable to commit orders: "
        unableToCommit.forEach((order, index)=> {
          if(index === 0) {
            message += order;
          } else {
            message += `, ${order}`
          }
        })
        message += "."
        this.$store.dispatch('ADD_NOTIFICATION', { text: message , type: 'error' });
      }
      let commitMessage ="Committed Orders: "
      if(ableToCommit.length > 0){
        ableToCommit.forEach((order, index)=> {
          if(index === 0) {
            commitMessage += order;
          } else {
            commitMessage += `, ${order}`
          }
        })
        commitMessage += "."
      }
      if(committedRows.length <= 0) return;
      this.commitOrders(committedRows, commitMessage)
    },
    deleteConfirmed(){
      this.multipleOrders ?
      this.deleteMultipleRows() :
      this.deleteOrder(this.orderId)
    },
    deleteMultipleRows(){
      let deletedRows = []
      this.selectedRows.forEach(row => {
        deletedRows.push(row.Id)
      })
      deletedRows.sort(function(a,b){ return b - a; })
      OrderService.deleteMultiple(deletedRows)
        .then(() => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: "Selected Orders have been deleted" , type: 'success' });
          // for (var i = deletedRows.length -1; i >= 0; i--){
          //   let index = this.orders.map(order => order.Id).indexOf(deletedRows[i])

          //   this.orders.splice(index,1);
          // }
          this.dataGridUpdateKey = this.dataGridUpdateKey + 1;
          this.selectedRows = []
          this.$store.dispatch('UPDATE_FAVORITES');
        })
        .catch((err) => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
        })
        .finally(() => {
          this.toggleDeleteCheck();
        })
    },

    deleteOrder(){
      OrderService.delete({id: this.orderId})
        .then((res) => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: "Order has been deleted" , type: 'success' });
          this.dataGridUpdateKey = this.dataGridUpdateKey + 1;
          this.$store.dispatch('UPDATE_FAVORITES');
        })
        .catch((err) => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
        })
        .finally(()=> {
          this.toggleDeleteCheck();
        })

    },
    undeleteOrder(orderId){
      OrderService.undelete({id: orderId})
        .then((res) => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: "Order has been restored" , type: 'success' });
          this.dataGridUpdateKey = this.dataGridUpdateKey + 1;
          this.$store.dispatch('UPDATE_FAVORITES');
        })
        .catch((err) => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
        })
    },
    selectedRowsChanged(rows){
      this.selectedRows = rows;
    },
    getFilteredOrders(){
        // If orderStatus is 5 (Deleted), we want to show only deleted orders
        // Otherwise, use the selected status and don't include deleted
        const isDeletedStatus = this.orderSearch.orderStatus === 5;

        let data = {
          PartNumber: this.orderSearch.productNumber,
          PartDescription: this.orderSearch.productDescription,
          StockCode: this.orderSearch.stockCode,
          // If viewing deleted orders, send "All" status (4) to backend
          OrderStatusId: isDeletedStatus ? 4 : this.orderSearch.orderStatus,
          Manufacturer: this.orderSearch.manufacturer,
          OrderOwner: this.orderSearch.owner,
          // Include deleted orders only when "Deleted" status is selected
          IncludeDeleted: isDeletedStatus,
          // Show only deleted orders when "Deleted" status is selected
          OnlyDeleted: isDeletedStatus
        };
        // this.dataSource = getDataSource('Orders/Search', data)
        this.dataSource = OrderService.filtered(this.dataGridKey, data)
        //console.log(this.dataSource);

    },
    getOrders(){
        //console.log(this.dataGridKey);
        this.dataSource = OrderService.getDataSource(this.dataGridKey)
        //console.log('DataSource: ', this.dataSource);
    },
    onStateResetClick() {
      this.dataGridKey = null;
      // clearFilter("search");
    },
    async getManufacturers(){
      // console.log(this.dataGridKey);
      this.manufacturersByDealer = await DealerService.manufacturersByDealer() ;
      //console.log(this.manufacturersByDealer);
    },
  },
  computed: {
    ...mapState(['currentUser', 'usStates']),
    selectedRowsEmpty(){
      return this.selectedRows.length <= 0
    },
    currentUserRole(){
        return getKeyByValue(userRoleEnum, this.currentUser.UserRoleId);
    },
    canViewDeletedOrders(){
      // Authorization is now handled on the backend
      return this.currentUser.CanViewDeletedOrders || false;
    },
    orderStatusOptionsFiltered(){
      // Filter out the "Deleted" option if user doesn't have access
      return this.orderStatusOptions.filter(option => {
        if (option.requiresDeletedAccess) {
          return this.canViewDeletedOrders;
        }
        return true;
      });
    },
    dynamicColumns(){
        let cols = [...this.defaultcolumns];
        // Show status column when viewing deleted orders
        if (this.orderSearch.orderStatus === 5 && this.canViewDeletedOrders) {
            cols.find(col => col.value === 'IsDeleted').visible = true;
        } else {
            cols.find(col => col.value === 'IsDeleted').visible = false;
        }
        return cols;
    },

  },
  watch: {
    'orderSearch.orderStatus'() {
      this.getFilteredOrders();
    }
  },
  mounted() {
    this.isLimitedTransferUser = this.currentUser.IsLimitedTransferUser;
  },
  async created(){
    this.getOrders();
    if(this.currentUserRole === 'SmartSales Admin'){
      this.$router.push({name: 'DealerSearch'})
    } else this.getManufacturers();
  }
};

</script>
<style lang="scss" scoped>
  .order-search-page {
    // max-width: 1800px;
  }
  .icon-btn{
    border: none;
    background-color: transparent;
    padding: 0px;
  }
  .btn-wrapper{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    &.center{
      justify-content: space-around;
      align-items: center;
    }

    .btn {
      margin: 5px;
    }
  }
  .search-button {
    margin-top: 24px;
    display: flex;
    flex-direction: row-reverse;
  }
  .modal-wrapper{
    width: 300px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    &.modal-wrapper-wide {
      width: 450px;
    }
  }
  .subheader-wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon-group{
      color: $primary;
      i{
        margin: 5px;
        cursor: pointer;
      }
    }
  }
  .dxSelect {
    z-index: 15;
    margin-top: 40px;
    position: absolute;
    max-height: 300px;
    overflow: scroll;
    width: -webkit-fill-available;
    border: solid 5px black;
  }


  .current-product {
    // padding-top: 11px;
  }

  // .dxSelect:hover  {
  //   background-color: black !important;
  // }

  .current-value {
    font-weight: bold;
  }

  .options {
    // padding: 20px;
    background-color: rgba(191, 191, 191, 0.15);
    // position: absolute;
    // right: 0;
    // top: 0;
    // bottom: 0;
    // width: 260px;
  }

  .caption {
    font-weight: 500;
    font-size: 18px;
  }

  .option {
    // margin-top: 10px;
  }

</style>
